'use client';

import Bowser from 'bowser';
import { basicLogger } from 'launchdarkly-js-client-sdk';
import { LDProvider, ProviderConfig } from 'launchdarkly-react-client-sdk';
import { ReactNode } from 'react';

interface LaunchDarklyProviderProps {
  children: ReactNode;
}

const browserInfo =
  typeof window !== 'undefined' ? Bowser.getParser(window.navigator.userAgent) : null;
const browser = browserInfo?.getBrowserName();
const platform = browserInfo?.getOSName();
const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : undefined;

const config: ProviderConfig = {
  clientSideID: process.env.NEXT_PUBLIC_REACT_APP_LD_KEY,
  context: {
    device: {
      browser,
      key: userAgent,
      platform,
    },
    kind: 'multi',
    user: {
      anonymous: true,
    },
  },
  options: {
    evaluationReasons: false,
    logger: basicLogger({ level: process.env.ENVIRONMENT === 'dv' ? 'debug' : 'error' }),
    sendEventsOnlyForVariation: true,
  },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
};

function LaunchDarklyProvider({ children }: LaunchDarklyProviderProps) {
  return <LDProvider {...config}>{children}</LDProvider>;
}

export default LaunchDarklyProvider as typeof LaunchDarklyProvider;
